import { func } from 'prop-types';
import { object, string } from 'yup';
import { Form, Field } from 'react-final-form';
import Input from '../Forms/input';
import Message from '../Forms/message';
import { InputWrapper, FormSection, SectionLabel, Content, ButtonsWrapper } from '../Forms/common';
import { validateFormValues } from '../Forms/formValidation';
import Button from '../StoraEnsoComponents/Button';


const validationSchema = object({
  projectID: string()
    .nullable(true)
    .trim()
    .required('Project ID is required')
});

// TODO
// - handle loading/error
function CalculatePrediction({
  handleFormSubmit,
}) {

  return (
    <Form
      onSubmit={handleFormSubmit}
      validate={validateFormValues({
        schema: validationSchema
      })}
      initialValues={{
        projectID: ''
      }}
      render={({ handleSubmit }) => (
        <FormSection>
          <SectionLabel>Calculate prediction</SectionLabel>
          <Content>
            <Field name="projectID">
              {({ input, meta }) => (
                <InputWrapper>
                  <label>Project ID</label>
                  <Input type="text" {...input} {...meta} />
                  {
                    meta.touched && meta.error && (
                      <Message isError>{meta.error}</Message>
                    )
                  }
                </InputWrapper>
              )}
            </Field>
            <ButtonsWrapper>
              <Button type="submit" onClick={handleSubmit}>
                Calculate
              </Button>
            </ButtonsWrapper>
          </Content>
        </FormSection>
      )}
    />
  );
}

CalculatePrediction.propTypes = {
  handleFormSubmit: func.isRequired,
}

export default CalculatePrediction;